// extracted by mini-css-extract-plugin
export var circle = "_fv-1";
export var exitConfirmationModal = "_fv-5";
export var iframe = "_fv-0";
export var offline = "_fv-3";
export var online = "_fv-2";
export var workstationSelectError = "_fv-4";